import React from 'react';
import { Link } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
const TopStory = ({
  topStoryTitle,
  topStoryIcon,
  title,
  previewText,
  pageContent,
  publishedDate,
  slug,
}) => {
  return (
    <div className="top-story-container">
      <div className="top-story-inner">
        <LitStructuredText data={topStoryTitle} basic />
        <div className="top-story-preview">
          <div className="top-story-preview-inner">
            <div className="top-story-icon">
              <LitImage image={topStoryIcon} alt="speech bubble icon" />
            </div>
            <div className="top-story-content">
              <h4>{title}</h4>
              <p>{previewText}</p>
              <div className="top-story-information">
                <span>{new Date(publishedDate).toLocaleString()}</span>
                <Link className="button-blue" to={slug}>
                  Read now
                </Link>
              </div>
            </div>
            <div className="top-story-image"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopStory;
